/* eslint-disable react-refresh/only-export-components */
import PropTypes from 'prop-types';

const statusColors = {
  Available: '#1e7e34', // Darker green
  Charging: '#117a8b', // Darker cyan
  Faulted: '#a71d2a', // Darker red
  Finishing: '#6f42c1', // Darker purple
  Reserved: '#d39e00',
  Preparing: 'gold', // Darker gray for preparing
  Default: '#000', // Default color
};

function CSS2({ status, ...props }) {
  const strokeColor = statusColors[status] || statusColors.Default;

  return (
    <svg
      viewBox="0 0 122 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M79 4c13.5 0 24 13.5 24 30 0 13.41-7.803 28.237-20.969 36.192C93.855 71.68 103 81.772 103 94c0 13.255-10.745 24-24 24H43c-13.255 0-24-10.745-24-24 0-12.228 9.145-22.32 20.969-23.81C26.803 62.237 19 47.41 19 34 19 17.5 29.5 4 43 4h36z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M43 76h36c9.941 0 18 8.059 18 18s-8.059 18-18 18H43c-9.941 0-18-8.059-18-18s8.059-18 18-18z"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={77.5}
        cy={94}
        r={12}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={43}
        cy={94}
        strokeWidth={2}
        r={12}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={77.5} cy={94} r={3} fill="#fff" />
      <circle cx={43} cy={94} r={3} fill="#fff" />
      <path
        clipRule="evenodd"
        strokeWidth={2}
        d="M43 10h36c9 0 18 10.5 18 24 0 18-16.5 36-36 36S25 52 25 34c0-13.5 9-24 18-24z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={71.5}
        cy={52}
        strokeWidth={2}
        r={7.5}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={50.5}
        cy={52}
        strokeWidth={2}
        r={7.5}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={71.5} cy={52} r={3} fill="#fff" />
      <circle cx={50.5} cy={52} r={3} fill="#fff" />
      <circle
        cx={82}
        cy={32.5}
        strokeWidth={2}
        r={7.5}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={61}
        cy={32.5}
        r={7.5}
        strokeWidth={2}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={40}
        strokeWidth={2}
        cy={32.5}
        r={7.5}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={82} cy={32.5} r={3} fill="#fff" />
      <circle cx={61} cy={32.5} r={3} fill="#fff" />
      <circle cx={40} cy={32.5} r={3} fill="#fff" />
      <circle
        cx={71.5}
        cy={19}
        r={3}
        strokeWidth={2}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={50.5}
        cy={19}
        r={3}
        strokeWidth={2}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
CSS2.propTypes = {
  status: PropTypes.string,
};

function Type2({ status, ...props }) {
  const strokeColor = statusColors[status] || statusColors.Default;
  return (
    <svg
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M60 103.5c25.5 0 48-22.5 48-48 0-1.44-.058-2.9-.174-4.365l-.099-1.101a55.68 55.68 0 00-.43-3.306l-.189-1.1v0l-.212-1.096C103.92 29.94 94.8 16.5 78 16.5H42c-16.8 0-25.92 13.44-28.896 28.032l-.212 1.096v0l-.188 1.1A55.343 55.343 0 0012 55.5c0 25.5 22.5 48 48 48z"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M42 28.5h36c10.5 0 18 10.5 18 27 0 19.5-16.5 36-36 36S24 75 24 55.5c0-16.5 7.5-27 18-27z"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={72}
        cy={73.5}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={72} cy={73.5} r={3} fill="#fff" />
      <circle
        cx={48}
        cy={73.5}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={48} cy={73.5} r={3} fill="#fff" />
      <circle
        cx={84}
        cy={52.5}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={84} cy={52.5} r={3} fill="#fff" />
      <circle
        cx={60}
        cy={52.5}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={60} cy={52.5} r={3} fill="#fff" />
      <circle
        cx={36}
        cy={52.5}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={36} cy={52.5} r={3} fill="#fff" />
      <circle
        cx={72}
        cy={37.5}
        r={4.5}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={48}
        cy={37.5}
        r={4.5}
        strokeWidth={2}
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
Type2.propTypes = {
  status: PropTypes.string,
};

function GBT({ status, ...props }) {
  const strokeColor = statusColors[status] || statusColors.Default;
  return (
    <svg
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M60 103.5c25.5 0 48-22.5 48-48 0-1.44-.058-2.9-.174-4.365l-.099-1.101a55.68 55.68 0 00-.43-3.306l-.189-1.1v0l-.212-1.096C103.92 29.94 94.8 16.5 78 16.5H42c-16.8 0-25.92 13.44-28.896 28.032l-.212 1.096v0l-.188 1.1A55.343 55.343 0 0012 55.5c0 25.5 22.5 48 48 48z"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M42 28.5h36c10.5 0 18 10.5 18 27 0 19.5-16.5 36-36 36S24 75 24 55.5c0-16.5 7.5-27 18-27z"
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={75}
        cy={78}
        r={3}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={60}
        cy={78}
        r={6}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={45}
        cy={78}
        r={3}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={76.5}
        cy={60}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={43.5}
        cy={60}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={76.5}
        cy={60}
        r={4.5}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={43.5}
        cy={60}
        r={4.5}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={60}
        cy={49.5}
        r={3}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={72}
        cy={37.5}
        r={3}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={60}
        cy={37.5}
        r={3}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={48}
        cy={37.5}
        r={3}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
GBT.propTypes = {
  status: PropTypes.string,
};

function Default({ status, ...props }) {
  const strokeColor = statusColors[status] || statusColors.Default;

  return (
    <svg
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={60}
        cy={60}
        r={48}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={60}
        cy={60}
        r={36}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={60}
        cy={81}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={60} cy={81} r={3} fill="#fff" />
      <circle
        cx={82.5}
        cy={70.5}
        r={4.5}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={37.5}
        cy={70.5}
        r={4.5}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={75}
        cy={45}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={75} cy={45} r={3} fill="#fff" />
      <circle
        cx={45}
        cy={45}
        r={9}
        stroke={strokeColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={45} cy={45} r={3} fill="#fff" />
    </svg>
  );
}
Default.propTypes = {
  status: PropTypes.string,
};

function Socket({ status, ...props }) {
  const strokeColor = statusColors[status] || statusColors.Default;

  return (
    <svg
      width={200}
      height={200}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={100} cy={100} r={95} stroke={strokeColor} />
      <circle cx={100} cy={100} r={85} fill="#fff" />
      <circle cx={100} cy={100} r={65} stroke={strokeColor} />
      <path d="M90 35a10 10 0 0120 0v15H90z" fill="#fff" />
      <path d="M90 150a10 10 0 0020 0v15H90z" fill="#fff" />
      <circle cx={100} cy={100} r={8} fill="#fff" />
      <circle cx={75} cy={75} r={8} fill="#fff" />
      <circle cx={125} cy={75} r={8} fill="#fff" />
      <circle cx={75} cy={125} r={8} fill="#fff" />
      <circle cx={125} cy={125} r={8} fill="#fff" />
    </svg>
  );
}
Socket.propTypes = {
  status: PropTypes.string,
};

export { CSS2, Type2, GBT, Default, Socket };
